var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    fill: "none",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.276.23a9.34 9.34 0 0 1 5.856.578 1 1 0 0 1-.814 1.827A7.336 7.336 0 0 0 2.015 8.85a7.336 7.336 0 0 0 9.397 7.515 7.34 7.34 0 0 0 5.248-6.732l.007-.296V8.57a1 1 0 0 1 2 0v.768a9.335 9.335 0 0 1-17.163 5.074A9.334 9.334 0 0 1 7.276.23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.959 1.965a1 1 0 0 1 1.415 1.413L10.04 11.72a1 1 0 0 1-1.415 0l-2.5-2.5A1 1 0 0 1 7.54 7.806l1.793 1.793z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5364ff11e511815bd61ad8172d91426e.svg";
export { ForwardRef as ReactComponent };